import React from 'react';
import PropTypes from 'prop-types';
import { countries } from '../../constants/parameters';
import { DeleteOutlined, EditOutlined } from '@ant-design/icons';
import { Table, Button, Popconfirm } from 'antd';
import { TableRowActions } from '../';
import { translateBooleanClassificator } from '../../utils/translateHelpers';

const CountriesTable = ({ dataSource, t, deleteClassifier, showModal }) => {
  const columns = [
    {
      title: t('tableGeneral.code'),
      dataIndex: countries.CODE,
    },
    {
      title: t('tableGeneral.en'),
      dataIndex: countries.ENGLISH,
    },
    {
      title: t('tableGeneral.et'),
      dataIndex: countries.ESTONIAN,
    },
    {
      title: t('countries.export'),
      dataIndex: countries.EXPORT,
      render: translateBooleanClassificator,
    },
    {
      title: t('tableGeneral.actions'),
      render: (value) => (
        <TableRowActions>
          <Button
            shape="circle"
            icon={<EditOutlined />}
            size="small"
            type="primary"
            onClick={() => showModal(value[countries.CODE])}
          />
          <span className="ant-divider" />
          <Popconfirm
            title={t('popconfirm.title')}
            onConfirm={() => deleteClassifier(value[countries.CODE])}
            okText={t('popconfirm.buttonYes')}
            cancelText={t('popconfirm.buttonNo')}
          >
            <Button
              shape="circle"
              icon={<DeleteOutlined />}
              size="small"
              type="primary"
            />
          </Popconfirm>
        </TableRowActions>
      ),
    },
  ];

  return (
    <Table
      rowKey={countries.CODE}
      dataSource={dataSource}
      columns={columns}
      pagination={false}
    />
  );
};

CountriesTable.propTypes = {
  dataSource: PropTypes.array,
  t: PropTypes.func.isRequired,
  deleteClassifier: PropTypes.func.isRequired,
  showModal: PropTypes.func.isRequired,
};

export default CountriesTable;
